export default "__VITE_ASSET__CoyH4awL__"